<template>
    <div class="app">
        <header class="header">
            <div class="header--inner">
                <div class="header--title" v-if="title">{{title}}</div>
                <div class="header--logos" v-else>
                </div>
                <div class="header--buttons">
                    <button class="header--button header--button--list" v-on:click="showWineList">
                        <icon-list class="header--button--icon" v-bind:active="wineListActive()"></icon-list>
                        <div class="header--button--list--count" v-if="wineListCount > 0">{{wineListCount}}</div>
                    </button>
                    <button class="header--button header--button--menu" v-on:click="showMenu"><icon-menu class="header--button--icon"></icon-menu></button>
                </div>
            </div>
            <transition name="fade">
                <nav class="header--navigation" v-if="menuVisible">
                    <div class="header--navigation--inner">
                        <button class="header--button header--navigation--close" v-on:click="hideMenu"><icon-close class="header--button--icon"></icon-close></button>
                        <ul class="header--navigation--list">
                            <li class="header--navigation--item"><router-link to="/" class="header--navigation--link">Home</router-link></li>
                            <li class="header--navigation--item"><router-link to="/weinsuche" class="header--navigation--link">Weinsuche</router-link></li>
                            <li class="header--navigation--item"><router-link to="/informationen" class="header--navigation--link">Wichtige Informationen</router-link></li>
                            <li class="header--navigation--item"><router-link to="/feedback" class="header--navigation--link">Feedback</router-link></li>
                            <li class="header--navigation--item"><router-link to="/impressum" class="header--navigation--link">Impressum</router-link></li>
                            <li class="header--navigation--item"><router-link to="/datenschutz" class="header--navigation--link">Datenschutz</router-link></li>
                        </ul>
                    </div>
                </nav>
            </transition>
        </header>
        <router-view/>
        <footer class="footer">
            <img src="./assets/images/events-logo.png" alt="Events LD SÜW" width="100" height="60">
        </footer>
    </div>
</template>

<script>
    import IconList from "./components/icons/IconList";
    import IconMenu from "./components/icons/IconMenu";
    import IconClose from "./components/icons/IconClose";

    export default {
        components: {
            IconClose,
            IconMenu,
            IconList
        },

        watch: {
            '$route' (to, from) {
                if (this.menuVisible) {
                    this.$store.commit('hideMenu');
                }
            }
        },

        computed: {
            title() {
                return this.$route.meta.title || false;
            },

            menuVisible() {
                return this.$store.state.menuVisible;
            },

            wineListCount() {
                return this.$store.state.wineList.length;
            }
        },

        methods: {
            showMenu() {
                this.$store.commit('showMenu');
            },

            hideMenu() {
                this.$store.commit('hideMenu');
            },

            showWineList() {
                this.$router.push('/merkzettel');
            },

            wineListActive() {
                return this.$route.path === '/merkzettel';
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/scss/all";

    .app {
        min-width: 320px;
        padding-top: 45px;
    }

    .header {
        @include shadow;

        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
    }

    .header--inner {
        max-width: $app-width;
        margin: 0 auto;
        padding: 7px 14px;
        display: flex;
        justify-content: space-between;
    }

    .header--title {
        font-size: 11px;
        text-transform: uppercase;
        font-family: $font-family-sans-serif;
        font-weight: bold;
        line-height: 2.8;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .header--buttons {
        flex-shrink: 0;
    }

    .header--button {
        border: none;
        padding: 0;
        line-height: 1;
        margin-left: 14px;
        background-color: transparent;

        &:active,
        &:focus {
            outline: none;
        }
    }

    .header--button--icon {
        height: 31px;
    }

    .header--button--list {
        position: relative;

        .header--button--icon {
            width: 16px;
        }
    }

    .header--button--list--count {
        position: absolute;
        width: 12px;
        height: 12px;
        line-height: 1.2;
        font-size: 10px;
        background-color: $primary;
        border-radius: 10px;
        bottom: 0;
        right: -6px;
    }

    .header--button--menu {
        .header--button--icon {
            width: 25px;
        }
    }

    .header--navigation {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: auto;
        background-color: #fff;
        z-index: 1000;
    }

    .header--navigation--inner {
        position: relative;
        max-width: $app-width;
        margin: 0 auto;
        padding: 7px 14px;
    }

    .header--navigation--close {
        position: absolute;
        top: 7px;
        right: 14px;

        .header--button--icon {
            width: 16px;
        }
    }

    .header--navigation--list {
        margin: 30px auto;
        padding: 0;
    }

    .header--navigation--item {
        list-style-type: none;
        padding: 10px 0;
        margin: 0;
        text-align: center;
    }

    .header--navigation--link {
        font-size: 16px;
        font-family: $font-family-sans-serif;
        font-weight: bold;
        color: #000;
        text-transform: uppercase;
        line-height: 1;
        text-decoration: none;

        &:hover,
        &:active {
            text-decoration: none;
        }

        &:focus {
            outline: none;
            color: $primary;
        }
    }

    .footer {
        border-top: 1px solid $primary;
        padding: 7px 0;
        text-align: center;
        margin-top: 30px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .25s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
